import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);

    this.setState({
      error,
      errorInfo,
    });
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            padding: "20px",
            backgroundColor: "#181512",
            color: "#f2e8d9",
            fontFamily: "Oswald, sans-serif",
          }}
        >
          <div
            style={{
              maxWidth: "600px",
              textAlign: "center",
              padding: "40px",
              backgroundColor: "rgba(12,16,12,.6)",
              border: "1px solid rgba(42,255,42,.15)",
              borderRadius: "8px",
            }}
          >
            <h1
              style={{
                fontSize: "32px",
                marginBottom: "16px",
                color: "#ee991a",
              }}
            >
              ⚠️ Something went wrong
            </h1>
            <p style={{ fontSize: "16px", marginBottom: "24px", opacity: 0.8 }}>
              An unexpected error occurred. The Zone is unpredictable.
            </p>

            {process.env.NODE_ENV === "development" && this.state.error ? (
              <details
                style={{
                  marginBottom: "24px",
                  textAlign: "left",
                  backgroundColor: "rgba(0,0,0,.3)",
                  padding: "16px",
                  borderRadius: "4px",
                  fontSize: "14px",
                  fontFamily: "monospace",
                }}
              >
                <summary style={{ cursor: "pointer", marginBottom: "8px" }}>
                  Error Details (Development Only)
                </summary>
                <pre style={{ overflow: "auto", fontSize: "12px" }}>
                  {this.state.error.toString()}
                  {this.state.errorInfo?.componentStack}
                </pre>
              </details>
            ) : null}

            <div
              style={{ display: "flex", gap: "12px", justifyContent: "center" }}
            >
              <button
                onClick={this.handleReset}
                style={{
                  padding: "12px 24px",
                  backgroundColor: "#f2e8d9",
                  color: "#000",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Try Again
              </button>
              <button
                onClick={() => (window.location.href = "/")}
                style={{
                  padding: "12px 24px",
                  backgroundColor: "transparent",
                  color: "#f2e8d9",
                  border: "1px solid rgba(42,255,42,.35)",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Go Home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
